import { ActionDisabledCondition, BulkUserAction, UserAction } from '@mediahaven/shared';
import { ApiFragment } from '@stylehaven/components';

/* Show errors
 * Available when:
 *  * Record has errors
 *      Failed jobs, stalled or rejected
 *
 * Disabled when:
 *  * Never
 */
export function GetShowErrorsUserAction(record: ApiFragment): UserAction {
    const hasErrors: boolean = record.hasErrors();

    const availableConditions: boolean[] = [hasErrors];
    const disableConditions: ActionDisabledCondition[] = [];

    return new UserAction(availableConditions, disableConditions);
}

/* Bulk show errors */
export function GetBulkShowErrorsUserAction(records: readonly ApiFragment[]): BulkUserAction {
    const availableConditions: boolean[] = [];
    const disableConditions: ActionDisabledCondition[] = [];

    return new BulkUserAction(records, availableConditions, disableConditions, GetShowErrorsUserAction);
}
